import { graphql, useFragment } from 'react-relay';

import {
  AppDialogConnectionDataTable_appDialogConnection$key,
  AppDialogConnectionDataTable_appDialogConnection$data,
} from '../../../relay/__generated__/AppDialogConnectionDataTable_appDialogConnection.graphql';
import DataTable, { DataTableProps } from '../../core/DataTable';
import DateText from '../../core/DateText';
import UserAvatarText from '../../user/UserAvatarText';
import AppDialogStatusLabel from '../AppDialogStatusLabel';

const AppDialogConnectionDataTable_appDialogConnection = graphql`
  fragment AppDialogConnectionDataTable_appDialogConnection on AppDialogConnection {
    edges {
      node {
        id
        title
        sequence
        startAt
        endAt
        order
        createdBy {
          ...UserAvatarText_user
        }
        ...AppDialogStatusLabel_appDialog
      }
    }
  }
`;

type Props = {
  appDialogConnection: AppDialogConnectionDataTable_appDialogConnection$key;
} & Omit<
  DataTableProps<AppDialogConnectionDataTable_appDialogConnection$data['edges'][number]['node']>,
  'rows' | 'columns'
>;

const AppDialogConnectionDataTable = ({ appDialogConnection, ...props }: Props) => {
  const { edges } = useFragment(AppDialogConnectionDataTable_appDialogConnection, appDialogConnection);

  return (
    <DataTable
      rows={edges.map(({ node }) => node).filter((node) => !!node)}
      columns={[
        {
          field: 'status',
          title: '상태',
          renderValue: (appDialog) => <AppDialogStatusLabel appDialog={appDialog} />,
          width: 80,
          align: 'center',
        },
        { field: 'sequence', title: 'ID', renderValue: ({ sequence }) => sequence, width: 80 },
        { field: 'order', title: '우선순위', renderValue: ({ order }) => order, width: 80 },
        { field: 'title', title: '제목', renderValue: ({ title }) => title, width: 524 },
        { field: 'startAt', title: '시작일', renderValue: ({ startAt }) => <DateText>{startAt}</DateText>, width: 160 },
        { field: 'endAt', title: '종료일', renderValue: ({ endAt }) => <DateText>{endAt}</DateText>, width: 160 },
        {
          field: 'createdBy',
          title: '제작자',
          renderValue: ({ createdBy }) => <UserAvatarText user={createdBy} />,
          width: 92,
        },
      ]}
      {...props}
    />
  );
};

export default AppDialogConnectionDataTable;
